import { ButtonColors } from "@/components/Button/types";

import Button from "../../../components/Button/Button";
import { DropdownValue } from "../../../components/PageHeader/actions/types/interfaces";
import Tooltip from "../../../components/Tooltip/Tooltip";

interface DialogActionsProps {
  onClose: () => void;
  isreadyToConfirm: DropdownValue | null | boolean | string | undefined;
  cancelButtonText: string;
  isLoading: boolean;
  loaderTitle?: string;
  confirmationButtonText?: string;
  cancelButtonTestId?: string;
  confirmationButtonTestId?: string;
  hasTooltip?: boolean;
  tooltipText?: string;
  hideAcceptButton?: boolean;
  hasTutorialHighlight?: boolean;
  disabledClose?: boolean;
  secondaryColor?: ButtonColors;
}

const DialogActions = ({
  onClose,
  isreadyToConfirm,
  isLoading,
  loaderTitle,
  confirmationButtonText,
  confirmationButtonTestId,
  cancelButtonTestId,
  cancelButtonText,
  hasTooltip,
  tooltipText,
  hideAcceptButton,
  hasTutorialHighlight,
  disabledClose,
  secondaryColor
}: DialogActionsProps) => {
  const acceptButton = () =>
    hideAcceptButton ? (
      <></>
    ) : (
      <Button
        data-testid={confirmationButtonTestId ?? "save-button"}
        id={confirmationButtonTestId}
        fullWidth
        variant="textOnly"
        size="normal"
        color="primary"
        type="submit"
        isLoading={isLoading}
        loaderTitle={loaderTitle}
        disabled={!isreadyToConfirm}
        hasTutorialHighlight={hasTutorialHighlight}
      >
        {confirmationButtonText}
      </Button>
    );

  return (
    <>
      <Button
        disabled={disabledClose}
        id={cancelButtonTestId}
        data-testid={cancelButtonTestId}
        fullWidth
        variant="textOnly"
        size="normal"
        color={secondaryColor ?? "secondary"}
        onClick={onClose}
      >
        {cancelButtonText}
      </Button>
      {hasTooltip && !hideAcceptButton ? (
        <Tooltip
          data-testid="accept-button-tooltip"
          title={tooltipText}
          placement="top"
          size="medium"
          hasArrow
        >
          <span>{acceptButton()}</span>
        </Tooltip>
      ) : (
        acceptButton()
      )}
    </>
  );
};

export default DialogActions;
